import React from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../authConfig";
import Button from "react-bootstrap/Button";
import GoogleLogin from 'react-google-login';

function goToIOS() {

}

export const IOSButton = () => {

    return (
        <>
            <Button variant="secondary" className="ml-auto" href="https://apps.apple.com/us/app/little-red-button/id1626397720">Download the iOS App</Button>
        </>
    );
    // client secret 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
}